// extracted by mini-css-extract-plugin
export default {"searchBar":"_c7e1f572","separator":"_ff579690"};